enum NotificationMode {
  AUTOMATIC = 1,
  MANUAL = 2,
}

export type NotificationModeType = keyof typeof NotificationMode

export const NotificationModes = (Object.keys(NotificationMode) as NotificationModeType[]).filter(
  (key) => typeof NotificationMode[key] === "number"
)
export default NotificationMode
